import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { BaseInputDirective } from '../base-input.directive';
import { CommonModule } from '@angular/common';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-text-area-input',
  templateUrl: './text-area-input.component.html',
  styleUrls: ['./text-area-input.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    CdkTextareaAutosize,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
})
export class TextAreaInputComponent extends BaseInputDirective implements OnInit, AfterViewInit {
  private changeDetector = inject(ChangeDetectorRef);

  @Input() showCharacterCount: boolean = true;
  @Input() minRows: number = 2;
  @Input() valueOverride;

  showTrimmedText: boolean;
  noteIsLong: boolean;
  trimmedText: string;

  
 


  ngOnInit() {
    super.ngOnInit();

    if (!this.controlName && !this.formControl) {
      this.formControl = new UntypedFormControl(this.valueOverride);
      this.evaluateDisabled(this.disabled);
    }
  }

  ngAfterViewInit() {
    const value = this.valueOverride?.toString() ?? this.formControl?.value?.toString() ?? '';
    if (value.length > 200) {
      this.noteIsLong = true;
      this.showTrimmedText = true;
      this.trimmedText = value.substring(0, 200) + '...';
    } else if (value.split(/\r\n|\r|\n/).length > 5) {
      this.noteIsLong = true;
      this.showTrimmedText = true;
      const splits = value.split(/\r\n|\r|\n/);
      this.trimmedText = splits.slice(0, 5).join('\n') + '...';
    }
    this.changeDetector.detectChanges();
  }
}
